import { ConnectionAuthType } from '../models/connection-auth-types.model';
import { ConnectionType } from '../models/connection-types.model';
import { CreateDataLakeConnectionRequest } from '../models/create-collibra-connection-request.model';

export type ConnectionRequestValues = {
    connectionAlias: string;
    businessDomainId: string;
    connectionAuthType: ConnectionAuthType;
    container: string;
    datalake: string;
    dfsDomain: string;
    clientId: string;
    clientSecret: string;
    useBringYourOwnSP: boolean;
    host: string;
    username: string;
    password: string;
    databaseName: string;
    port: number | null;
    isPushdown: boolean;
    isUnityCatalog: boolean;
    catalog: string;
};

export function createDataLakeConnectionRequest(values: ConnectionRequestValues): CreateDataLakeConnectionRequest {
    const request: CreateDataLakeConnectionRequest = {
        Alias: values.connectionAlias,
        BusinessDomainId: values.businessDomainId,
        DataLakePath: `abfss://${values.container}@${values.datalake}.${values.dfsDomain}/`,
        useBringYourOwnSP: values.useBringYourOwnSP,
    };

    if (values.useBringYourOwnSP) {
        request.ClientId = values.clientId;
        request.ClientSecret = values.clientSecret;
    }

    return request;
}

export function createSqlConnectionRequest(values: ConnectionRequestValues): object {
    return {
        Alias: values.connectionAlias,
        BusinessDomainId: values.businessDomainId,
        ConnectionAuthType: values.connectionAuthType,
        Host: values.host,
        Username: values.username,
        Password: values.password,
        DatabaseName: values.databaseName,
        Port: values.port,
        isPushdown: values.isPushdown,
    };
}

export function createDatabricksConnectionRequest(values: ConnectionRequestValues): object {
    const catalog = values.isUnityCatalog ? values.catalog.trim() : '';

    return {
        Alias: values.connectionAlias,
        BusinessDomainId: values.businessDomainId,
        ConnectionAuthType: values.connectionAuthType,
        Host: values.host,
        Username: values.username,
        Password: values.password,
        Port: values.port,
        isPushdown: values.isPushdown,
        ...(catalog && { Catalog: catalog }),
    };
}

export function createConnectionHost(values: ConnectionRequestValues, connectionType: ConnectionType): string {
    return connectionType === 'DataLake'
        ? `abfss://${values.container}@${values.datalake}.${values.dfsDomain}/`
        : values.host;
}
